import { render, staticRenderFns } from "./terms_conditions.vue?vue&type=template&id=6e8683c0&scoped=true&"
import script from "./terms_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8683c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VFlex,VImg})
